module.exports = __webpack_public_path__ + "static/media/emojis_22.eb56c6ff.svg";